import axios from "axios";
import { del, get, post, patch,  put } from "./session_types_api_helper";
import * as url from "./session_types_url_helper";





// Get features
export const getSessionTypes = () => get(url.GET_SESSION_TYPES);


// Add feature
export const addNewSessionType = (sessionType) => post(url.ADD_NEW_SESSION_TYPE, sessionType);
//export const addNewBranch = branch => post(url.ADD_NEW_SESSION, JSON.stringify(branch));




// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateSessionType = (sessionType) => patch(`${url.UPDATE_SESSION_TYPE}/${sessionType.id}`,  sessionType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteSessionType = (sessionType) => del(`${url.DELETE_SESSION_TYPE}/${sessionType.id}`);







export {
  //getLoggedInUser,
  
  
};
